module.exports = __webpack_public_path__ + "media/images/workation-five-f13b3b4c02bb51c0ac1c4d5563d83b9b.png";